import { useState } from "react";
import Modal from "react-modal";

const InfoModal = ({ className }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      <i onClick={openModal} className={className} />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Why KYC is Important"
        className="react-modal kyc-modal"
        overlayClassName="react-modal-overlay"
      >
        <button
          type="button"
          className="btn-close btn-close-white"
          aria-label="Close"
          onClick={closeModal}
        />
        <div>
          <h4>What is a Digital Wallet and Why Do You Need One?</h4>
          <p>
            A digital wallet is a tool that allows you to securely store, send,
            and receive digital assets, much like how a traditional wallet
            stores physical cash. However, instead of holding cash or cards,
            your digital wallet holds your digital currency, like RXG tokens,
            and other important information. This is an essential tool for
            interacting with the Rexla Hub and accessing all the services we
            offer.
          </p>
          <h4 className="mt-3">
            Why Do You Need a Wallet to Access the Rexla Hub?
          </h4>
          <p>
            In the digital age, transactions are moving away from traditional
            banks and financial institutions. When using Rexla Hub, you will
            need a wallet to interact with the services securely and
            efficiently. Just like you need a physical wallet to store money in
            the real world, your digital wallet serves as your secure passport
            to access the Rexla Hub.
          </p>
          <p>
            Unlike traditional bank accounts, your digital wallet is
            self-custody, meaning you are in control of your assets. You are
            responsible for your transactions and decisions. Unlike a bank where
            transactions are managed by them, in the world of digital wallets,
            you are in charge. This gives you peace of mind because it allows
            you to have full control of your funds and privacy. You decide how
            and when to make transactions, without the need for intermediaries.
          </p>

          <h4 className="mt-3">Why Hold RXG?</h4>
          <p>
            Although you can use regular money in the Rexla Hub, holding RXG
            tokens provides you with additional benefits. Think of RXG as your
            digital passport to the Rexla World. Holding RXG tokens opens up
            access to exclusive perks, such as discounts on various services,
            special offers, and access to exclusive content within the hub.
          </p>
          <p>
            By purchasing RXG, you’re not just using a currency; you’re joining
            a community with various advantages and rewards. It’s a way to
            enhance your experience and get more value from the products and
            services within Rexla.
          </p>

          <h4 className="mt-3">What Else Do You Need to Know?</h4>
          <p>
            If you have any further questions or need more information, we’ve
            provided a comprehensive FAQ section for you. Additionally, look out
            for REX, our AI companion, who is always here to help guide you
            through the Rexla Hub and answer any questions you may have.
          </p>

          <p className="mt-4">
            We’re here to make your journey into the world as smooth as
            possible. Welcome to the future with Rexla!
          </p>
          <p>Confidence is Key!</p>
        </div>
      </Modal>
    </>
  );
};

export default InfoModal;
